import m from "../../geodata/es2015/kazakhstanHigh";
window.am4geodata_kazakhstanHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/kazakhstanHigh.js
// module id = null
// module chunks = 